// src/components/admin/settings/PaymentsSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const PaymentsSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(data.settings);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Payment settings saved!');
      } else {
        toast.error('Failed to save');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading payment settings...</div>;

  return (
    <div className="settings-page">
      <h2>Payment Methods</h2>
      <p className="section-description">Configure payment methods and bank details</p>
      
      <form onSubmit={handleSubmit} className="settings-form">
        {/* Cash on Delivery */}
        <div className="payment-card">
          <div className="payment-header">
            <label className="checkbox-label">
              <input type="checkbox" name="payment_cod_enabled" checked={settings.payment_cod_enabled === '1'} onChange={handleChange} />
              <span className="payment-title">Cash on Delivery (COD)</span>
            </label>
          </div>
          {settings.payment_cod_enabled === '1' && (
            <div className="payment-details">
              <div className="form-group">
                <label>Payment Title</label>
                <input type="text" name="payment_cod_title" value={settings.payment_cod_title || 'Cash on Delivery'} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea name="payment_cod_description" value={settings.payment_cod_description || 'Pay when you receive your order'} onChange={handleChange} rows="2" />
              </div>
            </div>
          )}
        </div>
        
        {/* Bank Transfer */}
        <div className="payment-card">
          <div className="payment-header">
            <label className="checkbox-label">
              <input type="checkbox" name="payment_bank_transfer_enabled" checked={settings.payment_bank_transfer_enabled === '1'} onChange={handleChange} />
              <span className="payment-title">Direct Bank Transfer</span>
            </label>
          </div>
          {settings.payment_bank_transfer_enabled === '1' && (
            <div className="payment-details">
              <div className="form-group">
                <label>Payment Title</label>
                <input type="text" name="payment_bank_transfer_title" value={settings.payment_bank_transfer_title || 'Direct Bank Transfer'} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea name="payment_bank_transfer_description" value={settings.payment_bank_transfer_description || ''} onChange={handleChange} rows="2" />
              </div>
              
              <div className="bank-details">
                <h4>Bank Account Details</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Bank Name</label>
                    <input type="text" name="payment_bank_name" value={settings.payment_bank_name || ''} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Account Name</label>
                    <input type="text" name="payment_account_name" value={settings.payment_account_name || ''} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Account Number</label>
                    <input type="text" name="payment_account_number" value={settings.payment_account_number || ''} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>IBAN</label>
                    <input type="text" name="payment_iban" value={settings.payment_iban || ''} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>SWIFT/BIC Code</label>
                    <input type="text" name="payment_swift" value={settings.payment_swift || ''} onChange={handleChange} />
                  </div>
                  <div className="form-group">
                    <label>Bank Address</label>
                    <input type="text" name="payment_bank_address" value={settings.payment_bank_address || ''} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Additional Instructions</label>
                  <textarea name="payment_instructions" value={settings.payment_instructions || ''} onChange={handleChange} rows="3" />
                </div>
              </div>
            </div>
          )}
        </div>
        
        <button type="submit" disabled={saving} className="save-btn">{saving ? 'Saving...' : 'Save Payment Settings'}</button>
      </form>
    </div>
  );
};

export default PaymentsSettings;